import { useContext } from 'react';
import { GlueAPI } from '../glue';
export const useGlue = () => {
    return useContext(GlueAPI.Context);
};
//# sourceMappingURL=useGlue.js.map